/**
 * The feature videos (doc/video/features): one per feature, in English, Czech
 * and German, rendered as a 16:9 cut for the page that describes the feature
 * (public/video/features, shown by components/marketing/FeatureVideo.vue) and
 * a 9:16 reel for the affiliate materials (AFFILIATE_VIDEOS in
 * constants/affiliate.ts).
 *
 * After a new render, doc/video/features/publish.mjs copies the files over and
 * prints the lengths for `seconds` (they differ a little by language, as the
 * typed text does).
 */
export const FEATURE_VIDEO_LANGS = ['en', 'cs', 'de'] as const
export type FeatureVideoLang = typeof FEATURE_VIDEO_LANGS[number]

export const FEATURE_VIDEOS = {
  chat: { name: 'ai-chat-cv', seconds: { en: 34, cs: 34, de: 34 } },
  templates: { name: 'form-and-templates', seconds: { en: 38, cs: 39, de: 38 } },
  tailor: { name: 'tailor-to-job', seconds: { en: 29, cs: 29, de: 29 } },
  interview: { name: 'interview-prep', seconds: { en: 30, cs: 30, de: 31 } },
  letter: { name: 'cover-letter', seconds: { en: 25, cs: 25, de: 26 } },
} as const satisfies Record<string, { name: string, seconds: Record<FeatureVideoLang, number> }>

export type FeatureVideoId = keyof typeof FEATURE_VIDEOS

/** The video's language for a site locale: its own when there is a cut in it, English otherwise. */
export function featureVideoLang(locale: string): FeatureVideoLang {
  return (FEATURE_VIDEO_LANGS as readonly string[]).includes(locale) ? locale as FeatureVideoLang : 'en'
}

/** "/video/features/inmyresume-tailor-to-job-wide-cs.mp4", or the poster with ext "jpg". */
export function featureVideoPath(id: FeatureVideoId, lang: FeatureVideoLang, ext: 'mp4' | 'jpg' = 'mp4'): string {
  return `/video/features/inmyresume-${FEATURE_VIDEOS[id].name}-wide-${lang}.${ext}`
}
